import { combineReducers } from "@reduxjs/toolkit";

import layoutReducer from "../redux/layout";
import AuthReducer from "../redux/Auth";
import profileReducer from "../redux/profile";
import ticketReducer from "../redux/ticket";
import NotificationReducer from "../redux/Notification";

const reducer = combineReducers({
  layout: layoutReducer,
  auth: AuthReducer,
  profile: profileReducer,
  ticket: ticketReducer,
  notification: NotificationReducer,
});

const rootReducer = reducer;

export default rootReducer;
